import { API_URL } from "@constants/env";
import storageService from "@utils/localStorage.service";
import axios, { InternalAxiosRequestConfig } from "axios";

const defaultOptions = {
  baseURL: API_URL,
};

// Create instance
let apiInstance = axios.create(defaultOptions);

apiInstance.interceptors.request.use(function (
  config: InternalAxiosRequestConfig
) {
  const userLocalStorage = storageService.getLocalUserStorage();

  if (config.headers && userLocalStorage?.token) {
    config.headers.Authorization = userLocalStorage.token;
  }

  return config;
});

export default apiInstance;
